import {Component, OnInit} from '@angular/core';
import {WhatIsAnimaCloseAction, WhatIsAnimaModalComponent} from '../what-is-anima-modal/what-is-anima-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

@Component({
    selector: 'app-home-hero',
    templateUrl: './home-hero.component.html',
    styleUrls: ['./home-hero.component.scss']
})
export class HomeHeroComponent implements OnInit {

    constructor(
        private modalService: NgbModal,
        private router: Router
    ) {
    }

    ngOnInit(): void {
    }

    openWhatIsModal() {
        const modalRef = this.modalService.open(WhatIsAnimaModalComponent, {
            centered: true,
            windowClass: 'modal what-is-anima bg-transparent',
            backdrop: true,
            keyboard: true
        });
        modalRef.componentInstance.videoId = 'tXM9LNIXh9Q';
        modalRef.result.then(
            (res) => {
                if (res === WhatIsAnimaCloseAction.startTest) {
                    return this.goToTest();
                }
            }
        );
    }

    async goToTest() {
        return this.router.navigate(
            ['cs']
        );
    }

}
